import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from '../locales/zh.json';
import en from '../locales/en.json';
import th from '../locales/th.json';

const resources = {
  zh: { translation: zh },
  en: { translation: en },
  th: { translation: th }
};

i18n
  .use(LanguageDetector) // 自动检测浏览器语言
  .use(initReactI18next) // 绑定 react-i18next
  .init({
    resources,
    fallbackLng: 'zh', // 默认语言
    supportedLngs: ['zh', 'en', 'th'], // 支持的语言
    interpolation: {
      escapeValue: false // React 已经做了 XSS 防护
    },
    detection: {
      // 语言检测优先级
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'] // 缓存到 localStorage
    }
  });

export default i18n;
